// Only the first line matters for data-type detection — slicing a small
// prefix instead of reading the whole file keeps this cheap even for a
// 50+ MB upload. Shared by every upload modal that auto-detects data type
// (Health Plan, Compare Data) instead of asking the user to pick one.
const HEADER_LINE_READ_BYTES = 64 * 1024

export async function readCsvHeaderLine(file: File): Promise<string> {
  const prefix = await file.slice(0, HEADER_LINE_READ_BYTES).text()
  const newlineIndex = prefix.indexOf('\n')
  const line = newlineIndex === -1 ? prefix : prefix.slice(0, newlineIndex)
  // Strip a trailing \r from \r\n line endings (Windows/Excel exports).
  return line.endsWith('\r') ? line.slice(0, -1) : line
}
